import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../../../../base/BaseComponent";
import {DetailDialog} from "../../../../../resource/view/dialog/video/video";
import {Scrollbars} from "react-custom-scrollbars";
import {Empty, message} from "antd";
import {HistoryList} from "../../../../../editor/staticButton/history/history";
import moment from "moment";
import noFileIcon from "../../../../img/icon_noFile_1.png";
import {uuid} from "../../../../../../utils";
import {checkWordReplace} from "../tool/htmlFormat";

/**
 * creat by tianruojun
 * @description 安全中心网站稿件预览模块
 * @class WebNews
 * @extends {BaseComponent}
 */
let extIconList = {
    pdfs: {
        ext: ['pdf'],
        icon: '',
    },
    words: {
        ext: ['docx', 'doc'],
        icon: '',
    },
    zips: {
        ext: ['rar', 'zip', 'tar', 'gz', '7z', 'bz2', 'cab'],
        icon: '',
    },
    excels: {
        ext: ['xlsx', 'xls'],
        icon: '',
    },
    videos: {
        ext: ['avi', 'mp4', 'mov', 'mkv', 'rmvb', 'flv', 'rm', 'mpeg', 'mpg', 'ogv', 'wmv', 'webm'],
        getIconFun: 'videoIcon'
    },
    audios: {
        ext: ["mp3", "ogg", "webm", "wav", "mid"],
        icon: '',
    },
    imgs: {
        ext: ["jpg", "jpeg", "gif", "png", "bmp", "webp", "webp2", "tiff", "tif"],
        getIconFun: 'imgIcon'
    },
    ppts: {
        ext: ['pptx', 'ppt'],
        icon: '',
    },
    txts: {
        ext: ['txt', 'md', 'xml'],
        icon: '',
    },
    default: {
        ext: [],
        icon: noFileIcon
    }
};
export default class WebNews extends BaseComponent {
    static propTypes = {
        /**
         * @text 当前稿件检测记录数据
         * @category data
         */
        checkAll: PropTypes.object,
        /**
         * @text 当前稿件
         * @category data
         */
        dataSource: PropTypes.object.isRequired,
        /**
         * @text 当前稿件
         * @category data
         */
        checkAllWord: PropTypes.array,
        /**
         * @text 当前稿件配置数据
         * @category data
         */
        storyType: PropTypes.object.isRequired,
    };
    static defaultProps = {
    };

    /**
     * 处理睡觉的回调
     * @param {string} name 姓名
     */
    constructor(props) {
        super(props);
        this.state = {
            historyList: [], // 当前稿件历史记录
            historyIndex: 0,
            dataSource: props.dataSource
        }
    }
    componentWillMount() {
        // 获取历史记录
        this.getHistory();
        this.iconConfig();
    }
    componentDidMount() {
    }
    /**
     * 获取稿件历史记录
     */
    getHistory = () => {
        let getHistory = this.props.storyType?.getHistory;
        if(getHistory) {
            let url = getHistory.url;
            let method = getHistory.method;
            let id = this.props.checkAll?.data?.id;
            let idKey = getHistory.idKey;
            if(url && method && idKey) {
                let body = {
                    [idKey]:id
                };
                this.request({
                    url,
                    method,
                    body,
                    callBack: (historyList)=>{
                        if (historyList && historyList.length) {
                            historyList[0].historyItemClassName = "historyItemCheck";
                            this.setState({historyList},()=>{
                                this.attachIcon()
                            });
                        }
                    },
                    errorCallBack: (e) => {

                    }
                })
            }
        }
    };
    /**
     * 获取当前稿件数据源
     */
    getDataSource = () => {
        let {historyList,historyIndex} = this.state;
        if(historyList?.length && historyList[historyIndex]) {
            return historyList[historyIndex]?.history
        } else {
            return this.state.dataSource || {}
        }
    };
    /**
     * 获取打敏感标记后的数据
     */
    getData = () => {
        return this.setCheckWord(this.getDataSource());
    };
    /**
     * 获取打敏感标记后的数据
     */
    getAttach = () => {
        return this.getDataSource()?.attach;
    };
    /**
     * 给稿件数据打敏感词标记
     */
    setCheckWord = ({title="",ftitle="",summary="",content=""}) => {
        const {checkAllWord} = this.props;
        if(checkAllWord?.length) {
            checkAllWord.forEach(item=>{
                let itemWord = item.word;//错误词
                let currWord;
                let itemCorrectWord = item.correctWord;//正确词
                if (item.category === "SENSITIVE") {
                    currWord = '“' + itemWord + '”建议修改为：“' + itemCorrectWord + '”';
                } else {
                    currWord = '“' + itemWord + '”建议删除';
                }
                let replaceHtml = '<span class="itemWord word" check="'+currWord+'">'+itemWord+'</span>';
                content = checkWordReplace(content,item?.word,replaceHtml);
                title = checkWordReplace(title,item?.word,replaceHtml);
                ftitle = checkWordReplace(ftitle,item?.word,replaceHtml);
                summary = checkWordReplace(summary,item?.word,replaceHtml);
            })
        }
        return {title,ftitle,summary,content}
    };

    /**
     * 附件预览
     */
    preview(item){
        let urlHost = window.location.origin;
        if (urlHost.indexOf('127.0.0.1') > -1) {
            urlHost = 'http://192.168.120.50:9241'
        }
        console.log("item",item)
        let preivewUrl = encodeURIComponent(base64Encode(`${urlHost}${item.data && item.data.mp4Path ? item.data.mp4Path : item.url}?fullfilename=${item.name}`));
        let officeViewUrl = urlHost + '/kkfileview/onlinePreview' + "?url=" + preivewUrl;
        window.open(`${officeViewUrl}`, '_blank');
    };
    /**
     * 附件下载
     */
    downloadFile = (item) => {
        let path = item.url;
        path = path + '?download=1';
        window.open(`${path}`, '_blank');
    };
    // 附件图标
    attachIcon = () => {
        if(this.state.dataSource?.attach?.length) {
            this.state.dataSource.attach.forEach(async item => {
                let ext = this.getExt(item.name);
                item.icon = await this.getIcon({ext, url: item.url,attach:this.state.dataSource.attach});
                this.setState({})
            });
        }
        if(this.state.historyList?.length) {
            this.state.historyList.forEach((history,index)=>{
                if(history?.history?.attach?.length) {
                    history.history.attach.forEach(async item => {
                        let ext = this.getExt(item.name);
                        item.icon = await this.getIcon({ext, url: item.url,attach:this.state.historyList[index].history.attach});
                        this.setState({})
                    });
                }
            })
        }
    };
    getIcon = async ({ext,url="",attach}) => {
        let fileConfig = "default";
        for (let key in extIconList) {
            if (extIconList[key].ext.includes(ext)) {
                fileConfig = key
            }
        }
        if (extIconList[fileConfig].icon) {
            return extIconList[fileConfig].icon
        }
        if (extIconList[fileConfig].getIconFun && url) {
            return await this[extIconList[fileConfig].getIconFun](url,attach)
        }
        return ""
    };
    getExt = (name) => {
        if(!name || !name.includes('.')) return "";
        return name.split('.').at(-1).toLowerCase();
    };
    imgIcon = (url) => {
        return url
    };
    //视频图片接口
    videoIcon = (url,attach) => {
        return new Promise(((resolve, reject) => {
            if(url) {
                let params = {url: url};
                this.request({
                    url:'/storage/getStorageFileByUrl',
                    body: params,
                    callBack: (res) => {
                        if (res) {
                            if(attach) {
                                attach.forEach(item => {
                                    if (item.md5 === res.md5) {
                                        item.data = res
                                    }
                                })
                            }
                        }
                        if (res && res.thumbnailsPlayPath) {
                            resolve(res.thumbnailsPlayPath)
                        } else {
                            resolve("")
                        }
                    },
                    errorCallBack: (e) => {
                        resolve("")
                    }
                })
            } else {
                resolve("")
            }
        }));
    };
    // 附件图标配置项内容
    iconConfig = () => {
        extIconList.pdfs.icon = this.sysConfigGetValueByKey('icon_pdf_path', '/storage/C9EE69F38A7FD2B17A1E9D0BE2C5AD7A');
        extIconList.words.icon = this.sysConfigGetValueByKey('icon_word_path', '/storage/D472D1C574F0289E5C8731F8DD81AFF2');
        extIconList.txts.icon = this.sysConfigGetValueByKey('icon_txt_path', '/storage/252FB9797052C9D7DAC72E01B732E615');
        extIconList.excels.icon = this.sysConfigGetValueByKey('icon_excel_path', '/storage/EB84D79649B71985703DAB508BA18023');
        extIconList.zips.icon = this.sysConfigGetValueByKey('icon_zip_path', '/storage/2B63DF6CECDC9A70A3D7C31C86319906');
        extIconList.ppts.icon = this.sysConfigGetValueByKey('icon_ppt_path', '/storage/4123F1C5885E8E86706AEBD4B1778A7D');
        extIconList.audios.icon = this.sysConfigGetValueByKey('icon_audio_path', '/storage/9D74B50D3E3967F15C39C0F15560B56F');
    };
    render() {
        return (
            <div style={{background: '#ebf1f9',padding:'24px 0'}} className={'checkPage'}>
                {this.renderContent()}
                {this.renderLeft()}
                {this.renderRight()}
                <DetailDialog ref={e => this.detailDialog = e} path={this.state.videoPath}/>
            </div>
        )
    }
    // 内容部分
    renderContent = () => {
        const height = window.innerHeight - 24 - 20;
        const width = window.innerWidth - 680;// 左右各留340距离
        const publicStyle = {
            fontWeight: '400',
            marginBottom: '24px'
        };
        let {title='',ftitle='',summary='',content=''} = this.getData();
        return (
            <div className={'details_content'} style={{height: height,width}}>
                {/*标题*/}
                <Scrollbars autoHide autoHeightMax={height}>
                    <div style={{padding: '0 10px'}}>
                        <div
                            style={{
                                ...publicStyle,
                                fontSize: '22px',
                                textAlign: 'left',
                                color: 'rgba(0, 0, 0, 0.85)',
                            }}
                            dangerouslySetInnerHTML={{__html: title}}
                        >
                        </div>
                        {/*副标题*/}
                        <div
                            style={{
                                fontSize: '18px',
                                color: 'rgba(0, 0, 0, 0.85)',
                                ...publicStyle,
                            }}
                            dangerouslySetInnerHTML={{__html: ftitle}}
                        >
                        </div>
                        {/*摘要*/}
                        <div style={{
                            fontSize: 14,
                            color: 'rgba(0, 0, 0, 0.45)',
                            ...publicStyle,
                        }}
                             dangerouslySetInnerHTML={{__html: summary}}
                        >
                        </div>
                        {/*正文*/}
                        <div
                            style={{
                                fontSize: 16,
                                color: 'rgba(0, 0, 0, 0.65)',
                                ...publicStyle,
                            }}
                            dangerouslySetInnerHTML={{__html: content}}
                        >
                        </div>
                    </div>
                </Scrollbars>
            </div>
        )
    };
    // 附件部分
    renderLeft = () => {
        let attach = this.getAttach();
        if(!attach?.length) {
            return ""
        }
        return (
            <div style={{
                position: 'fixed',
                left: 3,
                top: 24,
                background: '#fff',
                width: 320,
                boxShadow: '0px 0px 5px #d9d3d3',
                borderRadius: '3px',
            }}>
                <div style={{
                    borderBottom: '1px solid #ccc',
                    height: 48,
                    fontSize: 16,
                    color: 'rgba(0, 0, 0, 0.65)',
                    padding: '14px 16px',
                    fontWeight: 'bolder'
                }}>附件
                </div>
                <Scrollbars autoHeight autoHeightMax={683} autoHide>
                    <div style={{paddingBottom:14}}>
                        {attach && attach.length ?
                            attach.map(item => {
                                return (
                                    <div className={'accessory_item'} key={item.md5}>
                                        <img src={item.icon} style={{marginRight: 10, width: 32, height: 32, objectFit: 'cover'}}/>
                                        <span className={'accessory_title'} title={item.name}>{item.name}</span>
                                        <span style={{
                                            color: this.themeBgColor,
                                            cursor: 'pointer',
                                            marginRight: '14px'
                                        }}
                                              onClick={() => {
                                                  this.preview(item);
                                              }}
                                        >预览</span>
                                        <span style={{color: this.themeBgColor, cursor: 'pointer'}} onClick={() => {
                                            this.downloadFile(item)
                                        }}>下载</span>
                                    </div>
                                )
                            })
                            : <Empty style={{padding: '12px 0px'}}/>}
                    </div>
                </Scrollbars>
                <div style={{marginTop:10}}/>
            </div>
        )
    };
    // 历史记录部分
    renderRight = () => {
        let {historyList} = this.state;
        if(!historyList?.length) {
            return ""
        }
        return (
            <div style={{position: 'fixed', right: 110, top: -17, background: '#fff'}}>
                <HistoryList
                    isContentDetail={'contentSecurityCenter'}
                    itemComponentClick={(editor, item, historyIndex) => {
                        this.setState({historyIndex})
                    }}
                    itemComponentStyle={{height:64}}
                    itemComponent={HistoryItem}
                    title={<span style={{fontSize:16}}>历史记录</span>}
                    visible={true}
                    data={historyList}
                />
            </div>
        )
    };
}
function base64Encode(str) {
    // 对字符串进行编码
    let encode = encodeURI(str);
    // 对编码的字符串转化base64
    let base64 = btoa(encode);
    return base64;
}
class HistoryItem extends Component {
    static defaultProps = {
        style: {},
        className: "historyItem",
        onClick: () => {
        }
    };

    render() {
        let {item} = this.props;
        return <div onClick={() => {
            this.props.onClick()
        }} className={this.props.className} style={{
            borderLeft: '3px solid #24B481',
            borderRadius: 3,
            padding: 10,
            borderColor: this.props.color, ...this.props.style
        }}>
            <table cellPadding={0} cellSpacing={0} border={0} width={"100%"} height={"100%"}>
                <tbody>
                <tr>
                    <td valign={"middle"}>
                        <div title={item.title} className={"plan-pointer showTwoText"}
                             style={{
                                 marginRight: 20,
                                 paddingLeft: 5,
                                 width: 240,
                                 overflow:'hidden',
                                 textOverflow:'ellipsis',
                                 display:'-webkit-box',
                                 WebkitBoxOrient:'vertical',
                                 WebkitLineClamp:'1',
                             }}
                        >
                            {item.operator ? item.operator : "错误数据"}
                        </div>
                    </td>
                </tr>
                <tr>
                    <td valign={"middle"}>
                        <div className={"plan-pointer"} style={{
                            marginRight: 20,
                            paddingLeft: 5,
                            color: "#ada4a4"
                        }}>{moment(item.createTime).format("yyyy-MM-DD HH:mm:ss")}</div>
                    </td>
                </tr>
                </tbody>
            </table>
            <style>{`
                .checkPage .historyItem:hover{
                    background: #ccd9eb !important;
                    border-left-color: #ccd9eb !important;
                }
                .checkPage .historyItemCheck{
                    border-left-color: rgb(18, 100, 201) !important;
                    background: #ebf1f9 !important
                }
                .checkPage .historyItem{
                    border-left-color: #f5f8fc !important;
                    background: #f5f8fc
                }
            `}</style>
        </div>
    }
}